
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ultimas",
      function () {
        return require("private-next-pages/ultimas/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ultimas"])
      });
    }
  